import React from 'react';
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import ContentAccordion from "../components/ContentAccordion/ContentAccordion";
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import store from "../store";
import {Helmet} from "react-helmet";

const TermsAndConditions = () => {

  return (
    <div className="wrapper mb36">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Legal" ? row.sections.map((section) => {
                        return section.title === "Terms & Conditions" ? <meta name="description" content={section.content['seo-description']}/> : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs pageTitle="Terms & Conditions"/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/home/page-components/text-block/terms-conditions-heading.html"
      />

      <ContentAccordion jsonDataUrl="./content/home/page-components/accordion/terms-conditions.json"/>
    </div>
  )

};

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/pages/TermsAndConditions.js